import React, { useContext, useEffect } from 'react';
import { Table, Icon, Button } from 'semantic-ui-react';
import './PersonRow.css';
import Highlighter from 'react-highlight-words';
import cn from 'classnames';
import StaffCategoryBadges from './StaffCategoryBadges/StaffCategoryBadges';
import { CartContext, SHALOCH_CUSTOMER_IDS } from '../contexts/CartProvider';
import { CUSTOMER_ID } from '../config';
import { getWithExpiry } from '../services/localStorageService';

const customerId = getWithExpiry(CUSTOMER_ID);
const AddRemovePaidButton = ({ id, selections, setSelections, paidFor }) => {
  const { updateCart, cart } = useContext(CartContext);
 
  const handleSelect = (recordId, value) => {
    setSelections((prevSelections) => {
      const newSelections = {
        ...prevSelections,
        [recordId]: value,
      };
      return newSelections;
    });
  };
 
  useEffect(() => {
    const selectedIds = Object.entries(selections).reduce(
      (accum, [key, value]) => {
        if (value) {
          return accum.concat(Number.parseInt(key, 10));
        }
        return accum;
      },
      []
    );
    updateCart(SHALOCH_CUSTOMER_IDS, selectedIds);
  }, [selections]);
 
  // Check if this row is for the current customer
  const isCurrentCustomer = id === customerId;
 
  if (paidFor) {
    return <span className="ordered-and-paid">ordered and paid</span>;
  }
 
  return cart[SHALOCH_CUSTOMER_IDS] &&
    cart[SHALOCH_CUSTOMER_IDS].includes(id) ? (
    <Button
      className="btn-remove-from-cart"
      onClick={() => handleSelect(id, false)}
      basic
      color="red"
      disabled={isCurrentCustomer}
    >
      <Icon name="minus circle" />
      Added to Cart
    </Button>
  ) : (
    <Button
      style={{ marginTop: '0 !important' }}
      className="btn-add-to-cart"
      basic
      color="blue"
      onClick={() => handleSelect(id, true)}
      disabled={isCurrentCustomer}
    >
      <Icon name="plus circle" />
      Add to Cart
    </Button>
  );
};

const PersonRow = ({
  customerId,
  firstNames,
  lastName,
  title,
  addressLine1,
  searchTerm,
  selections,
  setSelections,
  staffCategoryIds,
  staffCategories,
}) => {
  const { paidForCustomers = [] } = useContext(CartContext);
  const paidFor = paidForCustomers.includes(customerId);
  const fullName = `${lastName}, ${title} ${firstNames ? firstNames : ''}`;

  const isItemSelected = (recordId) => selections[recordId];
  const labelName = (id) => {
    if (!staffCategories || !staffCategories.length) return '';
    const idNum =
      typeof id === 'string' && id.match(/^\d+$/) ? parseInt(id, 10) : id;
    const found = staffCategories.find(({ staffCategoryId }) =>
      staffCategoryId === idNum || staffCategoryId.toString() === id.toString()
    );
    return found && found.category ? found.category : '';
  };

  return (
    <Table.Row
      className={cn('record-table-row', {
        selected: isItemSelected(customerId),
        'paid-for': paidFor,
      })}
    >
      <Table.Cell>
        <div className="add-remove-customer">
          <AddRemovePaidButton
            id={customerId}
            selections={selections}
            setSelections={setSelections}
            paidFor={paidFor}
          />
          <div className="name-address-content">
            <div className="name-inside-cell">
              <Highlighter
                highlightClassName="highlight"
                searchWords={searchTerm.split(' ')}
                autoEscape={true}
                textToHighlight={fullName}
              />
            </div>
            <div className="address-inside-cell">
              <Highlighter
                highlightClassName="highlight"
                searchWords={searchTerm.split(' ')}
                autoEscape={true}
                textToHighlight={addressLine1}
              />
            </div>
          </div>
          <div className="categories">
            {staffCategoryIds && (
              <StaffCategoryBadges
                labelName={labelName}
                staffCategoryIds={staffCategoryIds}
              />
            )}
          </div>
          {isItemSelected(customerId) && (
            <div className="green-check">
              <Icon
                className="green-check-icon"
                name="check circle"
                size="large"
              />
            </div>
          )}

          {paidFor && (
            <div className="paid-for-icon-section">
              <Icon className="paid-for-icon" name="lock" />
            </div>
          )}
        </div>
      </Table.Cell>
    </Table.Row>
  );
};

export default PersonRow;
